import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';
import { getConsignmentRuleApiErrorMessage } from '../../utils/consignment-rule.util';

export default function useArchiveConsignmentRule() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const archiveConsignmentRule = async (id) => {
    setIsSuccess(null);
    try {
      setIsLoading(true);
      const response = await fleetApi.post(`/consignment-rule/${id}/archive`);
      setIsSuccess(true);
      toast.success(response.data?.message || 'Règle de consigne archivée.');
    } catch (error) {
      setIsSuccess(false);
      toast.error(getConsignmentRuleApiErrorMessage(error));
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, isSuccess, archiveConsignmentRule };
}
